import { render, staticRenderFns } from "./ScrollUpButton.vue?vue&type=template&id=32ba83de&scoped=true&"
import script from "./ScrollUpButton.vue?vue&type=script&lang=js&"
export * from "./ScrollUpButton.vue?vue&type=script&lang=js&"
import style0 from "./ScrollUpButton.vue?vue&type=style&index=0&id=32ba83de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ba83de",
  null
  
)

export default component.exports